import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import LocalizedStrings from 'react-localization';
import Modal from 'react-bootstrap4-modal';

import { deletePatient, resendPasswordForPatient } from './epics-patients';
import SinglePatientDetails from './components/Patient-details';
import { Notification } from './components/Notifications';

import Svgs from '../Common/Svgs';
import { StaticRoutePaths } from '../Common/ClientRoutes';
import localStorage from '../Common/LocalStorage';
import { translations } from '../Common/Translations';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang') !== undefined ? localStorage.getFromStorage('lang') : 'en');

class PatientDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
            notificationType: ''
        };
    }

    getPatientId = () => {
        const url = this.props.location.pathname;
        return url.split('/').pop();
    };

    openModal = typeButton => {
        this.setState({
            ...this.state,
            modalOpen: true,
            notificationType: typeButton
        });
    };

    closeModal = () => {
        this.setState({
            ...this.state,
            modalOpen: false
        });
    };

    properActionHandler = (type, id, details) => {
        return type === 'DELETE' ? this.removePatient(id) : this.resendPatientPassword(id, details);
    };

    removePatient = id => {
        return deletePatient(id)
            .then(() => {
                this.props.history.push(StaticRoutePaths.PATIENTS);
                this.closeModal();
            })
            .catch(err => err);
    };

    //add function for resend password
    resendPatientPassword = (id, details) => {
        return resendPasswordForPatient(id, details)
            .then(() => {
                this.closeModal();
            })
            .catch(err => err);
    };
    render() {
        return (
            <div className="container">
                <div className="row qf-mb-100">
                    <div className="col-1 light-blue-bg text-center pt-3">
                        <span className="qf-page-icon">{Svgs.patients}</span>
                    </div>
                    <div className="col-11 white-bg px-5">
                        <div className="row">
                            <div className="col-9">
                                <h2 className="qf-page-title text-capitalize">
                                    <i className="fa fa-plus-square mr-2" />
                                    {strings.Patient_info}
                                </h2>
                            </div>
                            <div className="col-3 align-self-center text-right">
                                <Link to={StaticRoutePaths.PATIENTS} className="qf-back-btn">
                                    <i className="fa fa-chevron-left" />
                                    {strings.back}
                                </Link>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <hr className="qf-divider-line" />
                            </div>
                        </div>
                        <Modal visible={this.state.modalOpen} dialogClassName="modal-lg custom-modal">
                            <Notification
                                type={this.state.notificationType}
                                closeHandler={this.closeModal}
                                actionHandler={() =>
                                    this.properActionHandler(this.state.notificationType, this.getPatientId(), this.getPatientId())
                                }
                            />
                        </Modal>
                        <SinglePatientDetails
                            {...this.props.patientDetails}
                            patientId={this.getPatientId()}
                            openModal={this.openModal}
                            closeModal={this.closeModal}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(PatientDetails);



// WEBPACK FOOTER //
// ./src/customModules/Patients/component-details-patient.js